/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetDictionaryDto } from './GetDictionaryDto';
import {
    GetDictionaryDtoFromJSON,
    GetDictionaryDtoFromJSONTyped,
    GetDictionaryDtoToJSON,
} from './GetDictionaryDto';

/**
 * 
 * @export
 * @interface GetProjectPathPhaseDto
 */
export interface GetProjectPathPhaseDto {
    /**
     * 
     * @type {string}
     * @memberof GetProjectPathPhaseDto
     */
    id: string;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetProjectPathPhaseDto
     */
    pathPhaseDictionary: GetDictionaryDto;
    /**
     * 
     * @type {string}
     * @memberof GetProjectPathPhaseDto
     */
    pathPhaseDictionaryId: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetProjectPathPhaseDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the GetProjectPathPhaseDto interface.
 */
export function instanceOfGetProjectPathPhaseDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "pathPhaseDictionary" in value;
    isInstance = isInstance && "pathPhaseDictionaryId" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function GetProjectPathPhaseDtoFromJSON(json: any): GetProjectPathPhaseDto {
    return GetProjectPathPhaseDtoFromJSONTyped(json, false);
}

export function GetProjectPathPhaseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProjectPathPhaseDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'pathPhaseDictionary': GetDictionaryDtoFromJSON(json['pathPhaseDictionary']),
        'pathPhaseDictionaryId': json['pathPhaseDictionaryId'],
        'active': json['active'],
    };
}

export function GetProjectPathPhaseDtoToJSON(value?: GetProjectPathPhaseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'pathPhaseDictionary': GetDictionaryDtoToJSON(value.pathPhaseDictionary),
        'pathPhaseDictionaryId': value.pathPhaseDictionaryId,
        'active': value.active,
    };
}

